---@meta

---@param ... any
function print(...) end

function exit() end

function rollback() end

---@param v any
---@return string
function type(v) end

---@param cond any
---@param message any
---@return any
function assert(cond, message) end

---@param message any
---@param level integer
function error(message, level) end

---@param obj any
---@return table
function getmetatable(obj) end

---@param t table
function ipairs(t) end

---@param t table
---@param index any
function next(t, index) end

---@param t table
function pairs(t) end

---@param f function
---@param ... any
---@return boolean
---@return any
function pcall(f, ...) end

---@param v1 any
---@param v2 any
---@return boolean
function rawequal(v1, v2) end

---@param t table
---@param index any
---@return any
function rawget(t, index) end

---@param t table
---@param index any
---@param value any
function rawset(t, index, value) end

---@param index any
---@param ... any
function select(index, ...) end

---@param t table
---@param mt table
---@return table
function setmetatable(t, mt) end

---@param e any
---@param base integer
---@return number
function tonumber(e, base) end

---@param e any
---@return string
function tostring(e) end

---@param f function
---@param msgh function
function xpcall(f, msgh) end
